import { Button } from "@/components/ui/button";
import Permission from "../../../../common/components/auth/Permission";
import { FipeTable } from "../settings-blocks/ValueTableFipe";
import { InfoVehicleBlock } from "../settings-blocks/VehicleInfoCard";
import { VelotrackInfo } from "../settings-blocks/VehicleInfoVelotrack";
import { useVehicleDashboardContext } from "./useVehicleDashboardContext";
import VehicleDocumentsRow from "./VehicleDocumentsRow";
import { useState } from "react";
import { ModalViewLogs } from "@/modules/logsDetails/logsDetails.modal";

export function VehicleDashboardInformation() {
  const { vehicle, updateVehicleState } = useVehicleDashboardContext();
  const [isLogModalOpen, setIsLogModalOpen] = useState(false);
  return (
    <>
      <div className="tabs-border-line">
        <section className="tabs-item-style">
          <InfoVehicleBlock />
        </section>

        <div className="div-tabs-border-line"></div>

        <section className="tabs-item-style">
          <FipeTable />
        </section>

        <div className="div-tabs-border-line"></div>

        <section className="tabs-item-style">
          <VelotrackInfo />
        </section>

        <div className="div-tabs-border-line"></div>

        <section className="tabs-item-style">
          <Permission permission="edit:vehicles">
            {vehicle._id && (
              <VehicleDocumentsRow
                vehicleId={vehicle._id}
                crlvDocs={vehicle.crlvDocs || []}
                currentNFPath={vehicle.nf}
                filesSale={vehicle.filesSale ? vehicle.filesSale[0] : undefined}
                status={vehicle.status}
                crlv={vehicle.crlv}
                onVehicleUpdate={updateVehicleState}
              />
            )}
          </Permission>
        </section>
        <div className="div-tabs-border-line"></div>
        <section className="tabs-item-style">
          <div className="max-w-7xl mx-auto ">
            <Button
              color="red"
              variant="destructive"
              className={`bg-redPrimary text-white font-semibold p-2 rounded-md mb-2 sm:mb-0`}
              onClick={() => setIsLogModalOpen(true)}
            >
              Visualizar Logs
            </Button>
          </div>
        </section>
      </div>
      {isLogModalOpen && vehicle?._id && (
        <ModalViewLogs
          onClose={() => setIsLogModalOpen(false)}
          entity="vehicle" // Entidade fixa como solicitado
          entityId={vehicle._id} // ID do veículo do contexto
        />
      )}
    </>
  );
}
